import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AppComponent } from '../../app.component';

@Component({
    selector: 'mmoga-header',
    standalone: true,
    imports: [
        NgIf,
        RouterLink
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    private appComponent = inject(AppComponent);


    readonly homeRoute = '/home';

    get isLoggedIn(): boolean {
        return this.appComponent.isLoggedIn;
    }

    get userProfile() {
        return this.appComponent.userProfile;
    }

    get logoSrc(): string {
        return this.appComponent.isEyefinity
            ? 'assets/images/logos/Eyefinity_Logo_Color_RGB.png'
            : 'assets/images/logos/ModMed_Logo_Color_RGB.png';
    }

    get logoAlt(): string {
        return this.appComponent.isEyefinity ? 'Eyefinity logo' : 'ModMed logo';
    }

    public startSession() {
        this.appComponent.startSession();
    }

    public endSession() {
        this.appComponent.endSession();
    }
}
